document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js_faqAcoBtn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var content = btn.nextElementSibling;
      if (content) {
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
      }
      btn.classList.toggle('is_active');
      var icon = btn.querySelector('.js_acoIcn');
      if (icon) {
        icon.classList.toggle('is_active');
      }
    });
  });
});
